module.exports = __webpack_public_path__ + "stylesheets/main_a28a7ff81e672b579232f4a636899a3d.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/main.less
// module id = 3ksy
// module chunks = 55